/* unplugin-vue-components disabled */import { render } from "./Playlist.vue?vue&type=template&id=0d1f4b65&scoped=true&ts=true"
import script from "./Playlist.vue?vue&type=script&lang=ts"
export * from "./Playlist.vue?vue&type=script&lang=ts"

import "./Playlist.vue?vue&type=style&index=0&id=0d1f4b65&scoped=true&lang=css"
import "./Playlist.vue?vue&type=style&index=1&id=0d1f4b65&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1f4b65"],['__file',"src/views/playlist/Playlist.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d1f4b65"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d1f4b65', __exports__)) {
    console.log('reload')
    api.reload('0d1f4b65', __exports__)
  }
  
  module.hot.accept("./Playlist.vue?vue&type=template&id=0d1f4b65&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0d1f4b65', render)
  })

}


export default __exports__